<div class="datnek-ds-card suggestion-box invitation-box skeleton">
  <div class="suggestion-header" *ngIf="!isLoading">
    <div class="display-1">{{ titleCard }}</div>
  </div>
  <div class="suggestion-header" *ngIf="isLoading">
    <div class="line w-50 h15"></div>
  </div>
  <div class="suggestion-content">
    <nk-shared-invitation-list [userData]="dataUsers"></nk-shared-invitation-list>
  </div>
  <div class="suggestion-footer text-center">
    <datnek-ds-link
      label="Voir plus"
      *ngIf="!isLoading"
      (datnekdsClickOrTouch)="gotoInvitation($event)"
    ></datnek-ds-link>
    <div class="line w-50 h15 m-auto" *ngIf="isLoading"></div>
  </div>
</div>
